import { Text } from "../../Text/Text/Text";
import { Image } from "../../Image/Image/Image";
import styles from "./MemberSquare.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var memberSquareColor = ['#EBEBFC',
// WW220-10
'#E1F1B2',
// WW320-10
'#FBF3EB' // WW820-10
];
var fallbackImage = 'https://v.cdn.ww.com/media/system/cms/us/no-image-member.png';
export var MemberSquare = function MemberSquare(_ref) {
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? fallbackImage : _ref$image,
    headline = _ref.headline,
    subhead = _ref.subhead,
    quote = _ref.quote,
    color = _ref.color;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.container,
      style: {
        backgroundColor: color
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.top,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.imageWrapper,
          style: {
            border: "2px solid ".concat(color)
          },
          children: /*#__PURE__*/_jsx(Image, {
            className: styles.image,
            src: image ? image : fallbackImage,
            width: "42",
            height: "42",
            transformations: {
              image1x: {
                width: 42
              },
              image2x: {
                width: 84
              }
            },
            forceTwoXInSrc: true
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.header,
          children: [/*#__PURE__*/_jsx(Text, {
            typog: "headline7",
            children: headline
          }), /*#__PURE__*/_jsx(Text, {
            typog: "bodycopySmall",
            children: subhead
          })]
        })]
      }), /*#__PURE__*/_jsx(Text, {
        typog: "caption",
        richText: true,
        children: quote
      })]
    })]
  });
};